import React from "react";

const KeyPersonnel = () => {
  return (
    <section className="bg-gray-100 py-20">
      <div className="container mx-auto px-4">
        <h1 className="text-3xl font-bold text-center mb-12 underline">
          Key Personnel
        </h1>
        <div className="flex flex-wrap -mx-4">
          <div className="w-full md:w-1/2 px-4 mb-8 md:mb-0">
            <div className="bg-white p-8 rounded-lg shadow-lg h-full">
              <h2 className="text-2xl font-bold mb-4 text-blue-400">
                Guneet Singh Bhandal
              </h2>
              <p className="text-gray-700 leading-relaxed">
                Leveraging 20 years of shipping experience, he co-founded the
                company in February 2024 and currently serves as
                Director-Technical. A 2006 MERI Kolkata graduate, he rose to the
                rank of Chief Engineer before transitioning ashore. His prior
                role as Technical Superintendent at Seven Islands Shipping
                Limited featured in addition to normal vessel operations a
                proven track record of leading vital vessel optimization and
                strategic modernization projects.
              </p>
            </div>
          </div>
          <div className="w-full md:w-1/2 px-4">
            <div className="bg-white p-8 rounded-lg shadow-lg h-full">
              <h2 className="text-2xl font-bold mb-4 text-blue-400">
                Capt. Vishwanath Satish Shenoy
              </h2>
              <p className="text-gray-700 leading-relaxed">
                Bringing 27 years of diverse shipping expertise, he co-founded
                Sea Breeze Ship Management and presently serves as
                Director-Operations. He launched his maritime career in 1999 as
                a Deck Cadet, successfully rising to the rank of Master Mariner
                before transitioning ashore. Between 2017 and 2024, he managed
                vital operational and safety portfolios, serving as
                Marine/Operation Superintendent, Designated Person Ashore (DPA),
                and Company Security Officer (CSO).
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default KeyPersonnel;
